import { Button } from "@pacificoseguros/pixie/react/button";
import React, { useCallback } from "react";
import { Row } from "../../../components/layout/flex-layout";
import { SizedBox } from "../../../components/layout/sized-box";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { useWindowResize } from "../../../hooks/use-windows-resize";
import { useLanding } from "../providers/landing-provider";

export const LandingQuoteButton = () => {
    const { setOpenedQuotationPopup } = useLanding();
    const openPopup = useCallback(() => setOpenedQuotationPopup(true), []);
    const { isMobile } = useWindowResize();
    return (
        <SpacingBox
            data-testid="LandingQuoteButton"
            pt={isMobile ? 40 : 10}
            pb={40}
        >
            <Row justify="center">
                <SizedBox width={300}>
                    <Button
                        data-testid="LandingQuoteButtonElm"
                        kind="alternative"
                        fluid
                        onClick={openPopup}
                        id="quote-button"
                    >
                        <b>Cotiza y compra aquí</b>
                    </Button>
                </SizedBox>
            </Row>
        </SpacingBox>
    );
};
